import { regSub } from 'nike-re-framejs';

regSub('loginInProgress', db => db.getIn(['account', 'loginInProgress']));
